import { environment } from '../../../../../../../shared/src/lib/environments/environment';
import { NavItem } from '../../vertical/sidebar/nav-item/nav-item';

export const navItems: NavItem[] = [
  {
    navCap: 'Home',
  },
  // ...(environment.enableDashboard ? [
  //   {
  //     displayName: 'Dashboard',
  //     iconName: '',
  //     route: '/starter',
  //   }
  // ] : []),

  {
    displayName: 'Home',
    iconName: '',
    route: 'home/users',
  },
  {
    displayName: 'Home-V2',
    iconName: '',
    route: 'home/users-v2',
  },
  {
    displayName: 'Reports',
    iconName: '',
    route: 'home/report',
  },

  {
    displayName: 'Reports-V2',
    iconName: '',
    route: 'home/report-v2',
  },
  {
    displayName: 'Account Statement',
    iconName: '',
    route: 'home/account-statement',
  },
  {
    displayName: 'Betting P/L',
    iconName: '',
    route: 'home/settled-markets',
  },
  {
    displayName: 'Live PnL',
    iconName: '',
    route: 'home/live-markets',
  },
  {
    displayName: 'Bet Info',
    iconName: '',
    route: 'home/bet-info',
  },
  {
    displayName: 'White Labels',
    iconName: '',
    route: 'home/white-label',
  },

  {
    displayName: 'Betfair Accounts',
    iconName: '',
    route: 'configuration/betfair-accounts',
  },

  {
    displayName: 'Commission',
    iconName: '',
    route: 'home/commission',
  },
  {
    displayName: 'Static Commission',
    iconName: '',
    route: 'home/static-commission',
  },
  {
    displayName: 'Risk Taking',
    iconName: '',
    route: 'home/risk',
  },
  {
    displayName: 'Static Risk',
    iconName: '',
    route: 'home/static-risk',
  },
  {
    displayName: 'Exchange Rate',
    iconName: '',
    route: 'configuration/exchange-rate',
  },

  {
    displayName: 'Supported Countries',
    iconName: '',
    route: 'settings/supported-countries',
  },
  {
    displayName: 'Supported Sports',
    iconName: '',
    route: 'settings/supported-sports',
  },
  {
    displayName: 'Settlement',
    iconName: '',
    route: 'home/settlement',
  },
  {
    displayName: 'Roles',
    iconName: '',
    route: 'settings/roles',
  },
  {
    displayName: 'Change Password',
    iconName: '',
    route: 'home/reset-password',
  },
  {
    displayName: 'Bet Ticker V1',
    iconName: '',
    route: 'home/bet-ticker-v1',
  },
  {
    displayName: 'Bet Ticker',
    iconName: '',
    route: 'home/bet-ticker',
  },
  {
    displayName: 'KJsport9 Admin',
    iconName: '',
    route: 'home/kjsport9-admin',
  },
  {
    displayName: 'Feature Flags',
    iconName: '',
    route: 'configuration/feature-flags',
  },

  {
    displayName: 'Audit Log',
    iconName: '',
    route: 'home/audit-log',
  },
  {
    displayName: 'Services Config',
    iconName: '',
    route: 'home/services-config',
  },
  {
    displayName: 'Navigation Config',
    iconName: '',
    route: 'home/navigation-config',
  }
  ,
  {
    displayName: 'BM Fancy Config',
    iconName: '',
    route: 'home/bm-fancy-config',
  }
    ,
{
  displayName: '0% Commission Market',
  iconName: '',
  route: 'home/zero-commission-market',
},
  {
    displayName: 'Permissions',
    iconName: '',
    route: 'home/user-permissions',
  },
  {
    displayName: 'Operators',
    iconName: '',
    route: 'home/operators',
  }
];



